class Clients {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }
  update(client) {
    return this.apiClient.put(`com/clients/${client.id}/billing`, client.getUpdatePayload()).then(response => {
      return {
        identifier: response.data.identifier,
        companyName: response.data.company_name
      };
    });
  }
}

export { Clients };
//# sourceMappingURL=Clients.js.map
